import Search from "./search"

export default {
  path: `/`,
  name: `Search`,
  title: `Search Movies`,
  component: Search,
  exact: true,
  nav: true
}
